<template>
<div>
  <v-text-field persistent-hint
    v-model='threeWords'
    label='three.words.location'
    append-icon='mdi-open-in-new'
    hint='what3words gives every 3m square in the world a unique address of 3 words. This one can be used to navigate to the entrance of your office. Click the icon to refine'
    prefix='///'
    :loading='loading'
    @click:append='openThreeWords' />
</div>
</template>
<script>
import axios from 'axios'
const W3W_API_KEY = 'DE9K8CYP'
const W3W_BASE_URL = 'https://api.what3words.com/v3'
export default {
  name: 'w3w',
  props: {
    value: { type: String },
    latitude: { required: false },
    longitude: { required: false }
  },
  data () {
    return {
      threeWords: null,
      loading: false
    }
  },
  computed: {
    latlng () {
      return `${this.latitude},${this.longitude}`
    }
  },
  mounted () {
    if (this.value) {
      this.threeWords = this.value
    }
  },
  watch: {
    latlng: {
      immediate: true,
      handler () {
        if(!this.threeWords) {
          this.getThreeWords()
        }
      }
    },
    threeWords () {
      this.$emit('input', this.threeWords)
    }
  },
  methods: {
    openThreeWords () {
      let url = 'https://what3words.com/'
      if (this.threeWords) {
        url = url + this.threeWords
      }
      window.open(url,'_blank')
    },
    async getThreeWords () {
      if (this.latitude && this.longitude) {
        let url = `${W3W_BASE_URL}/convert-to-3wa?coordinates=${this.latlng}&key=${W3W_API_KEY}`
        this.loading = true
        let res = await axios.get(url)
        if (res.status === 200) {
          this.threeWords = res.data.words
        }
        if (res.status >= 200) {
          this.loading = false
        }
      }
    }
  }
}
</script>
